export default __webpack_public_path__ + "static/media/Products-bro.80879cf9.svg";